var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6924 10.6729H24.7549V30.3279H35.6924V10.6729Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4498 20.5C25.4498 16.5126 27.3167 12.9613 30.224 10.6725C28.0978 8.99868 25.415 8 22.4991 8C15.596 8 10 13.5964 10 20.5C10 27.4036 15.596 33 22.4991 33C25.415 33 28.0978 32.0013 30.224 30.3275C27.3167 28.0386 25.4498 24.4874 25.4498 20.5Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4477 20.5C50.4477 27.4035 44.8516 33 37.9486 33C35.0326 33 32.3498 32.0013 30.2236 30.3275C33.131 28.0386 34.9979 24.4874 34.9979 20.5C34.9979 16.5126 33.131 12.9613 30.2236 10.6725C32.3499 8.99868 35.0326 8 37.9486 8C44.8516 8 50.4477 13.5964 50.4477 20.5Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.4481,
    height: 25,
    fill: "white",
    transform: "translate(10 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment5);
export default __webpack_public_path__ + "static/media/payment5.79b85674f838652cc599fd4c2cd32f16.svg";
export { ForwardRef as ReactComponent };